import React, { useState, useEffect, useCallback } from 'react'
import * as Sentry from '@sentry/browser'

import { CircularProgress } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { post, URL_VARIABLES } from 'services/api'
import { verifyTokenRole } from 'config/tokenRouter'
import validateStageOnboarding from 'utils/validateStage'
import { roles } from 'utils/constants/roles'
import { setToken } from 'redux/reducers/token'
import Container from './styles'

export default (props) => {
  const { history, location } = props
  const { token } = useSelector((state) => state.token)
  const [sent, setSent] = useState(false)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const { state } = location

  const handleLoading = (newState) => {
    setLoading(newState)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.LIVENESS, handleLoading)
  }, [validateStageOnboarding])

  function sizeOf(base64) {
    try {
      const decoded = atob(base64)
      return decoded.length
    } catch {
      return -1
    }
  }

  const handleResponseError = useCallback(
    (file_base64) => {
      Sentry.captureException(new Error('Erro ao enviar selfie'), (scope) => {
        scope.clear()
        scope.setTag('step', 'liveness-upload')
        scope.setContext('context', {
          info: file_base64 && file_base64.substr(0, 30),
          bytes: sizeOf(file_base64),
        })
        return scope
      })

      history.replace({ pathname: '/liveness-fail' })
      return
    },
    [history],
  )

  const uploadFrame = useCallback(
    async (base64) => {
      const { data, status } = await post({
        url: '/onboarding/liveness',
        token,
        data: { base64 },
        source: URL_VARIABLES.ANTIFRAUDE,
      })

      if (data && status === 200) {
        dispatch(setToken(data.token))
        verifyTokenRole(data.token, history)
      } else {
        handleResponseError(base64)
      }
    },
    [dispatch, handleResponseError, history, token],
  )

  useEffect(() => {
    if (state && state.base64 && !sent) {
      setSent(true)
      uploadFrame(state.base64)
    }
  }, [state, uploadFrame, sent])

  return loading ? (
    <div className="loading">
      <div
        className="loading__container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <CircularProgress style={{ textAlign: 'center' }} />
      </div>
    </div>
  ) : (
    <Container>
      <div className="loading">
        <div className="loading__container">
          <CircularProgress />
        </div>
      </div>
      <div className="loading_text">
        <div className="loading_text__container">
          <p>Aguarde... Validando imagem!</p>
        </div>
      </div>
    </Container>
  )
}
